import { SmTableColumnStatus } from "./sm-table-column-status.model";

export class SmTableStatus {
    columnStatus: SmTableColumnStatus[] = [];
}
